/**
 * Interface for the parameters required by the clientDetailsBreadcrumb function.
 * 
 * @interface IParams
 * @property {Object} client - The client object containing name and id
 * @property {string} [client.name] - Optional name of the client
 * @property {number} client.id - The unique identifier of the client
 */
export interface IParams {
  client: { name?: string; id: number };
}

/**
 * Generates the breadcrumb navigation items for the client details page.
 * Creates a navigation path from Home through Clients to the specific client.
 * 
 * @param {IParams} props - The parameters containing client information
 * @returns {Array<{title: string, path: string}>} An array of breadcrumb items with titles and paths
 * 
 * @example
 * ```ts
 * const breadcrumbs = clientDetailsBreadcrumb({
 *   client: { name: "Example Client", id: 123 }
 * });
 * ```
 */
export const clientDetailsBreadcrumb = (props: IParams) => {
  const { client } = props;

  return [
    { title: "Home", path: "/" },
    { title: "Kunden", path: "/clients" },
    {
      title: client?.name ? client?.name : "Loading...",
      path: `/clients/${client.id}`,
    },
  ].filter((item) => item.title);
};
